// extracted by mini-css-extract-plugin
export default {"root":"AttachmentInfoSection_root__fW0dY"};